/**
 * Mirrors apps/api/src/modules/question-reports/question-reports.constants.ts. The web bundler
 * cannot import API source, so the values are repeated here and
 * `__parity__/questionReports.parity.test.ts` fails the build if they drift.
 */

export const QUESTION_REPORT_REASONS = ['wrong_answer_key', 'unclear_or_typo', 'broken_media', 'other'] as const;
export type QuestionReportReason = (typeof QUESTION_REPORT_REASONS)[number];

export const QUESTION_REPORT_STATUSES = ['OPEN', 'RESOLVED', 'DISMISSED'] as const;
export type QuestionReportStatus = (typeof QUESTION_REPORT_STATUSES)[number];

export const QUESTION_REPORT_COMMENT_MAX_LENGTH = 1000;

/** Reports are ON unless the author switched them off, so tests made before the setting existed are covered. */
export const isQuestionReportsEnabled = (settings: { questionReports?: boolean } | null | undefined): boolean =>
  settings?.questionReports !== false;
